// extracted by mini-css-extract-plugin
export default {"tabsContainer":"mobileInstructions_tabsContainer__qid2U","active":"mobileInstructions_active__OSPXC"};